<template>
    <div class="d-flex time-select">
        <select v-model="hour" class=" form-control" :disabled="disabled" :readonly="readonly">
            <option v-for="hourOpt in hours" :key="hourOpt" :value="hourOpt">{{ hourOpt }}</option>
        </select>
        <select v-model="meridiem" class=" form-control" :disabled="disabled" :readonly="readonly">
            <option v-for="meridiemOpt in meridiems" :key="meridiemOpt" :value="meridiemOpt">{{ meridiemOpt }}</option>
        </select>
        <input type="hidden" v-model="content" :name="name">
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                default: null,
            },
            value: {
                type: [Number, String],
                default: null,
            },
            disabled: {
                type: [String, Boolean],
                default: false
            },
            readonly: {
                type: [Boolean, Number],
                default: false,
            },
        },
        data() {
            return {
                content: this.value,
                hour: parseInt(this.value) !== 'NaN' ? parseInt(this.value) : '-',
                meridiem: this.value ? (this.value.toUpperCase().includes("AM") ? "AM" : 'PM') : '-',
                hours: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
                meridiems: ['AM', 'PM'],
            };
        },
        mounted() {
            var id = uniqid();
            $(this.$el).attr("id", id);
            var parent = $(this.$el).parent();

            parent.prev().attr("for", id);
            parent.next().attr("id", id+"-message");

        },
        watch: {
            hour(val){
                this.content = `${val} ${this.meridiem}`;
            },
            meridiem(val){
                this.content = `${this.hour} ${val}`;
            },
            content(val){
                this.$emit('input', val);
            },
            value(val){
                if (val) {
                    const [hour, meridiem] = val.split(" ");
                    this.hour = hour || 1;
                    this.meridiem = meridiem || 'am';
                }

                this.content = val || '';
            }

        }
    }
</script>

<style>
.time-select .select2 {
    width: 50%!important;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/elements/timepicker.vue